import type { Avatar } from '@seek/avatar';
import type { ComponentProps } from 'react';

export type AvatarVariant = ComponentProps<typeof Avatar>['variant'];

export type GetAvatarDisplayPropsParams = {
  hasEthicalHiring: boolean | undefined;
  imageUrl: string | undefined;
};

export const getAvatarDisplayProps = ({
  hasEthicalHiring, // When hasEthicalHiring is undefined, the consumer app does not have the concept of ethical hiring (e.g. candidate basic search).
  imageUrl,
}: GetAvatarDisplayPropsParams): {
  photoUrl: string | undefined;
  variant: AvatarVariant;
} => ({
  // When hasEthicalHiring is truthy, hide the photo (show initials only).
  photoUrl: hasEthicalHiring ? undefined : imageUrl,
  variant: 'initials',
});
